import { render, staticRenderFns } from "./ed-text-viewer-only.vue?vue&type=template&id=befa86b0&scoped=true&"
import script from "./ed-text-viewer-only.ts?vue&type=script&lang=ts&"
export * from "./ed-text-viewer-only.ts?vue&type=script&lang=ts&"
import style0 from "./ed-text-viewer-only.scss?vue&type=style&index=0&id=befa86b0&lang=scss&scoped=true&"
import style1 from "@/assets/styles/quill.snow.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befa86b0",
  null
  
)

export default component.exports